module.exports = __webpack_public_path__ + "img/chapter-1-thumb.c313c968.jpg";